import React from "react";
import { useAuth } from "@/context/AuthContext";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="p-8 lg:p-10">
      <div className="mb-8">
        <div className="label-eyebrow">Team</div>
        <h1 className="font-serif-display text-4xl text-[#0A1128] mt-2 tracking-tight">Settings</h1>
      </div>
      <div className="bg-white border border-[#E2E8F0] rounded-lg p-8 max-w-2xl">
        <div className="label-eyebrow mb-4">Your account</div>
        <div className="flex items-center gap-4">
          <Avatar className="w-14 h-14"><AvatarImage src={user?.picture} /><AvatarFallback>{user?.name?.[0]}</AvatarFallback></Avatar>
          <div>
            <div className="font-serif-display text-xl text-[#0A1128]">{user?.name}</div>
            <div className="text-sm text-slate-500">{user?.email}</div>
            <Badge className="mt-2 bg-[#C5A880]/20 text-[#8A6B33] rounded-full">{user?.role}</Badge>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-[#E2E8F0] text-sm text-slate-600 leading-relaxed">
          <div className="label-eyebrow mb-3">About the desk</div>
          Alpine Straits Property Partners is a boutique advisory helping Swiss capital access Singapore prime residential real estate — where a Free Trade Agreement grants zero Additional Buyer&apos;s Stamp Duty, saving investors ~20% versus most other foreign nationalities.
          <div className="mt-4 pt-4 border-t border-[#E2E8F0] flex items-center gap-4 text-xs">
            <div>
              <div className="label-eyebrow text-[10px] mb-1">Website</div>
              <a href="https://www.alpinestraitspartners.com.sg" target="_blank" rel="noopener noreferrer" className="text-[#0A1128] hover:text-[#C5A880] underline underline-offset-2">alpinestraitspartners.com.sg</a>
            </div>
            <div>
              <div className="label-eyebrow text-[10px] mb-1">Desk email</div>
              <a href="mailto:partner@alpinestraitspartners.com.sg" className="text-[#0A1128] hover:text-[#C5A880]">partner@alpinestraitspartners.com.sg</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
